var exports = {
  "Js": "reposListContainer__y67Az0",
  "jD": "skeletonItem__8VD0vU",
  "b6": "skeletonHeader__VHrAYv",
  "Aj": "skeletonDescription__1cUsJ7",
  "FB": "skeletonMetadata__XUTZHt",
};

module.exports = exports;
